<template>
	<div class="py-1 grid grid-flow-row grid-cols-3 gap-4 mt-auto" :class="labelXxl ? 'mb-4 pt-0' : 'py-1'">
			
		<!-- <h3 class="col-span-3 truncate text-2xl mb-4" v-if="labelXxl">{{ label }}</h3> -->
		
		<h3 class="text-2xl truncate text-right" v-if="labelXxl">{{ label }}</h3>
		<div class="col-span-2" v-if="labelXxl"></div>

		<div class="col-span-1 self-center text-right" v-if="!labelXxl">
			<div class="truncate">{{ label }}</div>
			<span :class="{ 'text-pink': delta > 0, 'text-blue': delta <= 0 }">
				{{ delta > 0 ? "+" : ""}}{{ delta.toFixed(2) }}
			</span>
		</div>

		<div class="py-1 flex-col  text-right" v-if="showLegend">
			<div class="">old</div>
			<div class="">mid</div>
			<div class="">new</div>
		</div>

		<div class="col-span-2 py-2">
			<vue-apex-charts
				style="border-left: 1px solid rgba(0, 0, 0, 0.1);"
				type="bar"
				:height="showLegend ? 64 : 32"
				:options="chartOptions"
				:series="chartSeries"
			/>
		</div>
		<!--<div class="text-right self-center">
			<div
				class="pl-2 pr-1 rounded-full inline-flex items-center font-medium"
				:class="{ 'text-pink': delta > 0, 'text-blue': delta <= 0 }"
				:style="{
					/*background:
						delta > 0 ? 'rgba(var(--vs-pink),.15)' : 'rgba(var(--vs-blue),.15)',
				*/}"
			>
				{{ delta > 0 ? "+" : ""}}{{ delta.toFixed(2) }}
				<feather-icon
					:icon="delta > 0 ? 'ArrowUpIcon' : 'ArrowDownIcon'"
					:class="{ 'text-pink': delta > 0, 'text-blue': delta <= 0 }"
					svgClasses="h-5 w-5"
				></feather-icon>
			</div>
		</div>-->
	</div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
export default {
	components: {
		VueApexCharts,
	},
	props: {
		ship: {
			type: Object,
			required: true,
		},
		label: {
			type: String,
			required: true,
		},
		field: {
			type: String,
			required: true,
		},
		period: {
			type: String,
			validator: (val) => ["old", "mid", "new"].includes(val),
		},
		comparison: {
			type: String,
			validator: (val) => ["old", "mid", "new"].includes(val),
		},
		showLegend: {
			type: Boolean,
			default: false,
		},
		labelXxl: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		getVal(period) {
			let obj = period == "new" ? "cluster" : "cluster_" + period,
				rawVal = "" + this.ship[obj][this.field];

			return rawVal.replace(",", ".") * 1; /* = 12 ! */
		},
		getBenchmarkVal(period) {
			let obj = "cluster_benchmark." + period,
				rawVal = "" + this.ship[obj][this.field];

			return rawVal.replace(",", ".") * 1; /* = 12 ! */
		}
	},
	computed: {
		delta() {
			return 0.0000000001 + (this.getVal(this.period) - this.getVal(this.comparison));
		},
		chartSeriesColors() {
			// we have three periods: old, mid, new
			// two of them are currently active - period and comparison
			// we compare the values of "period" and "comparison".
			let that = this;
			function c(p) {
				let c = "#d9d9d9"; // inactive
				if ([that.period, that.comparison].includes(p)) {
					c = that.delta > 0 ? "#e44a7f" : "#4a76c4";
				}
				return c;
			}

			return [c("old"), c("mid"), c("new")];
		},
		chartSeries() {
			return [
				{
					name: "data",
					data: [
						{
							x: "Old",
							y: this.getVal("old"),
							goals: [
								{
									name: "Expected",
									value: this.getBenchmarkVal("old"),
									strokeWidth: 2,
									strokeColor: '#cccccc'
								},
							],
						},

						{
							x: "Mid",
							y: this.getVal("mid"),
							goals: [
								{
									name: "Expected",
									value: this.getBenchmarkVal("mid"),
									strokeWidth: 2,
									strokeColor: '#cccccc'
								},
							],
						},

						{
							x: "New",
							y: this.getVal("new"),
							goals: [
								{
									name: "Expected",
									value: this.getBenchmarkVal("new"),
									strokeWidth: 2,
									strokeColor: '#cccccc'
								},
							],
						},
					],
				},
			];
		},
		chartOptions() {
			return {
				yaxis: {
					min: 0,
					max: 2,
				},
				xaxis: {
					//categories: ['old','mid','new'],
					axisBorder: {
						show: false,
						color: '#d9d9d9',
						height: 1,
						widht: 1,
						// offsetX: -1,
						// offsetY: 2
					},
				},
				yaxis: {
					axisBorder: {
						show: true,
						color: '#d9d9d9',
						height: 1,
						widht: 1,
						// offsetX: -1,
						// offsetY: 2
					},
				},
				colors: this.chartSeriesColors,
				plotOptions: {
					bar: {
						horizontal: true,
						borderRadius: 2,
						barHeight: "55%",
						distributed: true
					},
				},
				legend: {
					show: false,
				},
				dataLabels: {
					enabled: false,
				},
				chart: {
					type: "bar",
					toolbar: { show: false },
					sparkline: { enabled: true },
				},
				tooltip: {
					enabled: false,
				},
				states: {
					hover: {
						filter: {
							type: "none",
						},
					},
				},
			};
		},
	},
};
</script>